import { createAsyncThunk } from '@reduxjs/toolkit';
import { PrivateServices } from '../../../../../Services/axios/Private.Service';
import { checkFilter } from '../../../../Common/CommonUtils';
import { handleApiError } from '../../../../Common/ErrorHandler';

export const fetchPrivateSchedules = createAsyncThunk(
    'PrivateSchedules/fetchPrivateSchedules',
    async (filters) => {
        try {
            let filter = checkFilter(filters);
            const response = await PrivateServices.getAll(filter);
            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    }
);

export const updatePrivateSchedule = createAsyncThunk(
    'PrivateSchedules/updatePrivateSchedule',
    async (data) => {
        try {
            const formData = new FormData();
            formData.append('check_in_time', data.check_in_time);
            if (data.check_out_time) {
                formData.append('check_out_time', data.check_out_time);
            }

            await PrivateServices.update(data.id, formData);
            return true;
        } catch (error) {
            handleApiError(error);
        }
    }
);